import { Brain, DocumentTabType } from '@heidi/schema/ml-scribe';

import type { DocumentView } from './types';

export const mockEmptyDocument: DocumentView = {
  id: 'empty-document',
  session_id: 'session-id',
  creator_kinde_id: 'creator-kinde-id',
  index: 0,
  name: 'Untitled Document',
  template_id: null,
  ai_command_id: null,
  question: null,
  content: null,
  updated_dictation: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  deleted_at: null,
  brain: Brain.LEFT,
  document_tab_type: DocumentTabType.DOCUMENT,
};
